import React from 'react'
import {
    BackButton,
    Bloc,
    BlocIntField,
    Button,
    Conditionnal,
    Header,
    ProgressBar,
    Title,
} from '../ImportAll'

export default function Vue7() {
    return (
        <div>
            <div>
                <Conditionnal
                    linked_data_id="prj_type"
                    isEqualTo
                    targetDataValueCompare="RENEGOCIATION"
                >
                    <Conditionnal
                        linked_data_id="prj_usage"
                        isEqualTo
                        targetDataValueCompare="RES_PRINCIPALE"
                    >
                        <Header
                            title="J'estime mon prêt"
                            subTitle="Que comptez-vous faire de votre bien ?"
                        />
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id="prj_usage"
                        isNotEqualTo
                        targetDataValueCompare="RES_PRINCIPALE"
                    >
                        <Header
                            title="J'estime mon prêt"
                            subTitle="Dans votre logement actuel, vous êtes"
                        />
                    </Conditionnal>
                </Conditionnal>
                <Conditionnal
                    linked_data_id="prj_type"
                    isNotEqualTo
                    targetDataValueCompare="RENEGOCIATION"
                >
                    <Header
                        title="J'estime mon prêt"
                        subTitle="Dans votre logement actuel, vous êtes"
                    />
                </Conditionnal>
            </div>

            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <BackButton />
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={30} time={3} />
            </div>

            {/* 
                si non renego, affichage des cas d"habitation actuelle possible.
                affichage du "propriétaire" uniquement si "emp_proprio_last_2_ans" n'as pas explicitement été set a "NON"
            */}
            <Conditionnal
                linked_data_id="prj_type"
                isNotEqualTo
                targetDataValueCompare="RENEGOCIATION"
            >
                <div className="Container">
                    <Bloc
                        key="key47"
                        selectable
                        linked_data_id="emprunteurs_hab_actuelle"
                        linked_data_value="LOCATAIRE"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Locataire"
                    />
                    <Bloc
                        key="key49"
                        selectable
                        linked_data_id="emprunteurs_hab_actuelle"
                        linked_data_value="HEBERGE_GRATUITEMENT"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="Hébergé gratuitement"
                    />
                    <Bloc
                        key="key50"
                        selectable
                        linked_data_id="emprunteurs_hab_actuelle"
                        linked_data_value="LOGEMENT_FONCTION"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Logement de fonction"
                    />
                    <Conditionnal
                        linked_data_id="emp_proprio_last_2_ans"
                        isEqualTo
                        targetDataValueCompare="OUI"
                    >
                        <Bloc
                            key="key48"
                            selectable
                            linked_data_id="emprunteurs_hab_actuelle"
                            linked_data_value="PROPRIETAIRE"
                            nbcolumn={2}
                            droit
                            simpleWord
                            text1="Propriétaire"
                        />
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id="emp_proprio_last_2_ans"
                        isEmpty
                    >
                        <Bloc
                            key="key48"
                            selectable
                            linked_data_id="emprunteurs_hab_actuelle"
                            linked_data_value="PROPRIETAIRE"
                            nbcolumn={2}
                            droit
                            simpleWord
                            text1="Propriétaire"
                        />
                    </Conditionnal>
                </div>
            </Conditionnal>

            {/* 
                si renego,  affichage des cas d"habitation actuelle possible uniquement si prj usage n'est pas RP.
                affichage du propriétaire uniquement si 
            */}
            <Conditionnal
                linked_data_id="prj_type"
                isEqualTo
                targetDataValueCompare="RENEGOCIATION"
            >
                <div>
                    <Conditionnal
                        linked_data_id="prj_usage"
                        isNotEqualTo
                        targetDataValueCompare="RES_PRINCIPALE"
                    >
                        <div className="Container">
                            <Bloc
                                key="key47"
                                selectable
                                linked_data_id="emprunteurs_hab_actuelle"
                                linked_data_value="LOCATAIRE"
                                nbcolumn={2}
                                gauche
                                simpleWord
                                text1="Locataire"
                            />
                            <Bloc
                                key="key48"
                                selectable
                                linked_data_id="emprunteurs_hab_actuelle"
                                linked_data_value="PROPRIETAIRE"
                                nbcolumn={2}
                                droit
                                simpleWord
                                text1="Propriétaire"
                            />
                            <Bloc
                                key="key49"
                                selectable
                                linked_data_id="emprunteurs_hab_actuelle"
                                linked_data_value="HEBERGE_GRATUITEMENT"
                                nbcolumn={2}
                                gauche
                                simpleWord
                                text1="Hébergé gratuitement"
                            />
                            <Bloc
                                key="key50"
                                selectable
                                linked_data_id="emprunteurs_hab_actuelle"
                                linked_data_value="LOGEMENT_FONCTION"
                                nbcolumn={2}
                                droit
                                simpleWord
                                text1="Logement de fonction"
                            />
                        </div>
                    </Conditionnal>
                </div>
            </Conditionnal>

            {/* 
                SI est proprietaire 
                    Si projet travaux : on demande si garder / vendre aprés.
                    si projet non travaux : on demande si vendre avant ou aprés ou garder
            */}
            <Conditionnal
                linked_data_id="emprunteurs_hab_actuelle"
                isEqualTo
                targetDataValueCompare="PROPRIETAIRE"
            >
                <div className="Container">
                    <Conditionnal
                        linked_data_id="prj_type"
                        isEqualTo
                        targetDataValueCompare="RENEGOCIATION"
                    >
                        <Conditionnal
                            linked_data_id="prj_usage"
                            isNotEqualTo
                            targetDataValueCompare="RES_PRINCIPALE"
                        >
                            <Title maintitle="Que comptez-vous faire de votre bien ?" />
                        </Conditionnal>
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id="prj_type"
                        isNotEqualTo
                        targetDataValueCompare="RENEGOCIATION"
                    >
                        <Title maintitle="Que comptez-vous faire de votre bien ?" />
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id="prj_type"
                        isEqualTo
                        targetDataValueCompare="TRAVAUX"
                    >
                        <Bloc
                            key="keyvendre56"
                            selectable
                            linked_data_id="emp_hab_devenir"
                            linked_data_value="GARDER"
                            nbcolumn={2}
                            gauche
                            simpleWord
                            text1="Le garder"
                        />
                        <Bloc
                            key="keyvendre57"
                            selectable
                            linked_data_id="emp_hab_devenir"
                            linked_data_value="VENDRE_APRES"
                            nbcolumn={2}
                            droit
                            simpleWord
                            text1="Le vendre après"
                        />
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id="prj_type"
                        isNotEqualTo
                        targetDataValueCompare="TRAVAUX"
                    >
                        <Bloc
                            key="keyvendre53"
                            selectable
                            linked_data_id="emp_hab_devenir"
                            linked_data_value="GARDER"
                            nbcolumn={2}
                            gauche
                            simpleWord
                            text1="Le garder"
                        />
                        <Bloc
                            key="keyvendre54"
                            selectable
                            linked_data_id="emp_hab_devenir"
                            linked_data_value="VENDRE_AVANT"
                            nbcolumn={2}
                            droit
                            simpleWord
                            text1="Le vendre avant"
                        />
                        <Bloc
                            key="keyvendre55"
                            selectable
                            linked_data_id="emp_hab_devenir"
                            linked_data_value="VENDRE_APRES"
                            nbcolumn={2}
                            gauche
                            simpleWord
                            text1="Le vendre après"
                        />
                    </Conditionnal>

                    <BlocIntField
                        key="keydede56"
                        linked_data_id="emp_hab_devenir_valeur"
                        symbole=" €"
                        label="Valeur du bien"
                        placeholder="Ex : 150 000 €"
                    />
                </div>
                <Conditionnal
                    linked_data_id="emp_hab_devenir_valeur"
                    isNotEmpty
                >
                    <Conditionnal linked_data_id="emp_hab_devenir" isNotEmpty>
                        <div className="SubmitButtonContainer">
                            <Button text="Suivant" targetView={9} />
                        </div>
                    </Conditionnal>
                </Conditionnal>
            </Conditionnal>

            {/* 
						SI est locataire 
							Si projet usage est un locatif  : on demande directe le loyer car considéré comme gardé
							si projet non locatif : on demande si on garde la location actuelle aprés
								si garder on demande le loyer 
								si pas garder on continu
					 */}
            <Conditionnal
                linked_data_id="emprunteurs_hab_actuelle"
                isEqualTo
                targetDataValueCompare="LOCATAIRE"
            >
                <Conditionnal
                    linked_data_id="prj_usage"
                    isNotEqualTo
                    targetDataValueCompare="LOCATIF"
                >
                    <div className="Container">
                        <Title maintitle="Comptez-vous garder votre location actuelle après votre acquisition?" />
                        <Bloc
                            key="akey53"
                            selectable
                            linked_data_id="situation_habitation_actuelle_garder_location"
                            linked_data_value="OUI"
                            nbcolumn={2}
                            gauche
                            simpleWord
                            text1="Oui"
                        />
                        <Bloc
                            key="akey54"
                            selectable
                            linked_data_id="situation_habitation_actuelle_garder_location"
                            linked_data_value="NON"
                            nbcolumn={2}
                            droit
                            simpleWord
                            text1="Non"
                        />
                    </div>

                    <Conditionnal
                        linked_data_id="situation_habitation_actuelle_garder_location"
                        isEqualTo
                        targetDataValueCompare="NON"
                    >
                        <div className="SubmitButtonContainer">
                            <Button text="Suivant" targetView={9} />
                        </div>
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id="situation_habitation_actuelle_garder_location"
                        isEqualTo
                        targetDataValueCompare="OUI"
                    >
                        <div className="Container">
                            <BlocIntField
                                key="akey56"
                                linked_data_id="situation_habitation_actuelle_location_loyer"
                                symbole=" € / mois"
                                label="Loyer mensuel (hors charges)"
                                placeholder="Ex : 650 € / mois"
                            />
                        </div>
                        <Conditionnal
                            linked_data_id="situation_habitation_actuelle_location_loyer"
                            isNotEmpty
                        >
                            <div className="SubmitButtonContainer">
                                <Button text="Suivant" targetView={9} />
                            </div>
                        </Conditionnal>
                    </Conditionnal>
                </Conditionnal>
                <Conditionnal
                    linked_data_id="prj_usage"
                    isEqualTo
                    targetDataValueCompare="LOCATIF"
                >
                    <div className="Container">
                        <BlocIntField
                            key="akey56"
                            linked_data_id="situation_habitation_actuelle_location_loyer"
                            symbole=" € / mois"
                            label="Loyer mensuel (hors charges)"
                            placeholder="Ex : 650 € / mois"
                        />
                    </div>
                    <Conditionnal
                        linked_data_id="situation_habitation_actuelle_location_loyer"
                        isNotEmpty
                    >
                        <div className="SubmitButtonContainer">
                            <Button text="Suivant" targetView={9} />
                        </div>
                    </Conditionnal>
                </Conditionnal>
            </Conditionnal>

            <Conditionnal
                linked_data_id="emprunteurs_hab_actuelle"
                isEqualTo
                targetDataValueCompare="HEBERGE_GRATUITEMENT"
            >
                <div className="SubmitButtonContainer">
                    <Button text="Suivant" targetView={9} />
                </div>
            </Conditionnal>
            <Conditionnal
                linked_data_id="emprunteurs_hab_actuelle"
                isEqualTo
                targetDataValueCompare="LOGEMENT_FONCTION"
            >
                <div className="SubmitButtonContainer">
                    <Button text="Suivant" targetView={9} />
                </div>
            </Conditionnal>
        </div>
    )
}
